module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahead1-be45966ade27e0402610366454d930e0.jpg";